import { isAnalyticsEnabled } from './environment';
import logger from './logger';

type GAEventCategory = 'session' | 'account' | 'story' | 'comment' | 'like' | 'flag' | 'blogEntry' | 'view' | 'invite' | 'link' | 'calculator' | 'entityPledge' |
  'entity' | 'entityMembership' | 'image' | 'email' | 'app';
type GAEventAction = 'unhandledError' | 'create' | 'delete' | 'update' | 'sent' | 'click' | 'mutate' | 'verify' | 'initialize' | 'join';

/** Resolves true when ga is present; false after timeout (never rejects). */
const waitForGoogleAnalytics = (): Promise<boolean> => new Promise((resolve) => {
  if ((window as any).ga) {
    resolve(true);
    return;
  }
  const start = Date.now();
  const interval = setInterval(() => {
    if ((window as any).ga) {
      clearInterval(interval);
      resolve(true);
      return;
    }
    if (Date.now() - start > (10 * 1000)) {
      clearInterval(interval);
      resolve(false);
    }
  }, 500);
});

// execute this without blocking.
export const trackEvent = async (category: GAEventCategory, action: GAEventAction, label?: string, value?: number) => {
  if (!isAnalyticsEnabled) return;
  try {
    const ready = await waitForGoogleAnalytics();
    if (!ready) {
      logger.warn('Google Analytics unavailable');
      return;
    }
    if (value !== undefined) {
      (window as any).ga(
        'send',
        'event',
        category,
        action,
        label,
        value
      );
    } else if (label !== undefined) {
      (window as any).ga(
        'send',
        'event',
        category,
        action,
        label
      );
    } else {
      (window as any).ga(
        'send',
        'event',
        category,
        action
      );
    }
  } catch (_err) {
    logger.warn('Google Analytics unavailable');
  }
};

type GAAttributeField = 'campus' | 'team' | 'userType';

export const setAttribute = async (field: GAAttributeField, value: string) => {
  if (!isAnalyticsEnabled) return;
  try {
    const ready = await waitForGoogleAnalytics();
    if (!ready) {
      return;
    }
    (window as any).ga('set', field, value);
  } catch (_err) {
    // Staging / missing GA must not throw uncaught promise rejections.
  }
};
